export default __webpack_public_path__ + "static/media/spark_19.e2a46d5b.png";